import { GalleryItem } from './gallery-item';
import { FasciaApertura } from './fascia-apertura';
import { Localizzazione } from './localizzazione';
import { RaccomandazioneResponse, RaccomandazioneSource } from './raccomandazione';
import { Image } from '@ks89/angular-modal-gallery';

export class Poi {
    id: string;
    language?: string;
    title?: string;
    typeElement?: {
        key?: string,
        label?: string
    };

    categories?: Array<{
        key?: string,
        label?: string
    }>;

    categoriesKeys?: Array<string>;
    categoriesLabels?: string;

    shortDescription?: string;
    extendedDescription?: string;

    thumbnail?: string;
    image?: string;
    captionImage?: String;


    address?: string;
    nhouse?: string;
    city?: string;
    province?: string;
    zipCode?: number;
    geoLocation?: Localizzazione;

    telephone?: string;
    webSite?: string;
    email?: string;

    services?: Array<string>;
    languagesSpoken?: Array<string>;

    //Dovrebbe arrivare dal servizio, la stringa internaziolizzata
    typeOpening?: {
      key?: string;
      label?: string;
    };
    opening?: Array<FasciaApertura>;
    infoOpening?: string;

    airport?: string;
    highway?: string;
    transport?: string;
    carParks?: string;

    owner?: string;
    actualFunctions?: {
      key?: string;
      label?: string;
    };
    poiStatus?: {
      key?: string;
      label?: string;
    };
    reservation?: boolean;
    freeEntry?: boolean;
    price?: string;
    accessibility?: string;

    activities?: Array<string>;
    nRooms?: number;
    nBeds?: number;
    nBathroom?: number;

    //Potrei non considerarlo, perchè gli passiamo la lingua
    //translation?: Array<TraduzionePoi>;

    indirizzoEsteso?: string;

    distanceFromPoint?: {
        distance?: number,
        uom?: string;
    }

    isFavourite: boolean;
    keywords?: any;

    gallery?: any;
    galleryImages?: Image[];
}
